export type Lang = 'en' | 'ar';

export const translations = {
  en: {
    appName: 'Athan',
    allowLocation: 'Please allow location access to get prayer times.',
    calculationMethod: 'Calculation Method',
    latitude: 'Latitude',
    longitude: 'Longitude',
    athanSound: 'Athan Sound',
    enableAutoPlay: 'Enable Auto Play for Adhan',
    autoPlayEnabled: 'Auto Play Enabled',
    prayerTimes: 'Prayer Times',
    loadingPrayerTimes: 'Loading prayer times...',
    errorGettingLocation: 'Error getting location',
    errorGeoNotSupported: 'Geolocation is not supported. Please enter your coordinates manually.',
    errorFetchingTimes: 'Error fetching prayer times. Please try again.',
    errorFetchingTimesConn: 'Error fetching prayer times. Please check your connection.',
    fajr: 'Fajr',
    sunrise: 'Sunrise',
    dhuhr: 'Dhuhr',
    asr: 'Asr',
    maghrib: 'Maghrib',
    isha: 'Isha',
    qiblaDirection: 'Qibla Direction',
    qiblaAngle: 'Qibla Angle (from North)',
    deviceHeading: 'Device Heading',
    na: 'N/A',
    pointDeviceToQibla: 'Point your device towards the Qibla.',
    enableCompass: 'Enable Compass',
    gettingLocation: 'Getting location...',
    calculatingQibla: 'Calculating Qibla direction...',
    error: 'Error',
    langToggle: 'عربي',
  },
  ar: {
    appName: 'أذان',
    allowLocation: 'يرجى السماح بالوصول إلى الموقع للحصول على مواقيت الصلاة.',
    calculationMethod: 'طريقة الحساب',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    athanSound: 'صوت الأذان',
    enableAutoPlay: 'تفعيل التشغيل التلقائي للأذان',
    autoPlayEnabled: 'التشغيل التلقائي مفعل',
    prayerTimes: 'مواقيت الصلاة',
    loadingPrayerTimes: 'جاري تحميل مواقيت الصلاة...',
    errorGettingLocation: 'خطأ في الحصول على الموقع',
    errorGeoNotSupported: 'خدمة تحديد الموقع غير مدعومة. يرجى إدخال إحداثياتك يدوياً.',
    errorFetchingTimes: 'خطأ في جلب مواقيت الصلاة. يرجى المحاولة مرة أخرى.',
    errorFetchingTimesConn: 'خطأ في جلب مواقيت الصلاة. يرجى التحقق من اتصالك.',
    fajr: 'الفجر',
    sunrise: 'الشروق',
    dhuhr: 'الظهر',
    asr: 'العصر',
    maghrib: 'المغرب',
    isha: 'العشاء',
    qiblaDirection: 'اتجاه القبلة',
    qiblaAngle: 'زاوية القبلة (من الشمال)',
    deviceHeading: 'اتجاه الجهاز',
    na: 'غير متاح',
    pointDeviceToQibla: 'وجّه جهازك نحو القبلة.',
    enableCompass: 'تفعيل البوصلة',
    gettingLocation: 'جاري الحصول على الموقع...',
    calculatingQibla: 'جاري حساب اتجاه القبلة...',
    error: 'خطأ',
    langToggle: 'EN',
  },
} as const;

export const prayerLabels: Record<Lang, Record<string, string>> = {
  en: { Fajr: 'Fajr', Sunrise: 'Sunrise', Dhuhr: 'Dhuhr', Asr: 'Asr', Maghrib: 'Maghrib', Isha: 'Isha' },
  ar: { Fajr: 'الفجر', Sunrise: 'الشروق', Dhuhr: 'الظهر', Asr: 'العصر', Maghrib: 'المغرب', Isha: 'العشاء' },
};
